import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import CreateCampaignDialogErrorMixin from './create-campaign-dialog-error-mixin';

@Component
export default class CreateCampaignDialogFlowLandingErrorsMixin extends mixins(CreateCampaignDialogErrorMixin) {
  getLandingErrorCondition(ruleIndex: number, pathIndex: number, landingIndex: number): any[] {
    return [
      'rules', ruleIndex + 1,
      'paths', pathIndex + 1,
      'landings', landingIndex + 1
    ];
  }
  
  get landingGeneralErrorCondition() {
    return [ 'id' ];
  }

  get isGeneralError() {
    return this.getInvalidFieldsError([ 'id' ]);
  }

  get generalErrorMessages() {
    return this.getMessages(this.isGeneralError);
  }

  get landingWeigthErrorCondition() {
    return [ 'weight' ];
  }

  get isWeigthError() {
    return this.getInvalidFieldsError(this.landingWeigthErrorCondition);
  }

  get weigthErrorMessages() {
    return this.getMessages(this.isWeigthError);
  }
}